export default __webpack_public_path__ + "static/media/ContactUs-01.b237a182.jpg";